import React, {useState, useEffect} from "react";
// React Bootstrap
import {Form, FormControl, Image, Navbar, InputGroup} from "react-bootstrap";
// Componentes
// import UsuarioTarjeta from "./usuario_tarjeta";
// import AgregarUsuario from "./usuario_tarjeta_add";
import GenericExplorer from "../generic/GenericExplorer";
import LaicoTarjeta from "./LaicoTarjeta";
// Styled Components
import styled from "styled-components";
import LaicoAddTarjeta from "./LaicoAddTarjeta";
import TooltipIcon from "../generic/TooltipIcon";
import $ from "jquery";



const CustomNavBar = styled(Navbar)`
  min-width: 200px;
`;

const Laicos = ({ ruta, provinciaLogueado, ...props }) => {

  //console.log(provinciaLogueado)
  //Filters
  const [search, setSearch] = useState("");
  const [todosLaicos, setTodosLaicos] = useState(false);

  const [filterProvincia, setFilterProvincia] = useState("");
  const [provincias, setProvincias] = useState([]);

  useEffect(() => {
    handleGetDatosProvincia();
  }, []);

  const handleChangeSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleChangeTodasHermanas = () => {
    setTodosLaicos(!todosLaicos);
  };

  // A partir de los valores de los filtros obtiene el query string
  const getQueryString = () => {
    let count = "20";
    let type = "Laico";
    let findName = search ? search : "";
console.log(`?count=${count}&type=${type}&findName=${findName}&allLaico=${todosLaicos}&allUser=${todosLaicos}&provincia=${filterProvincia}`)
    return `?count=${count}&type=${type}&findName=${findName}&allLaico=${todosLaicos}&allUser=${todosLaicos}&provincia=${filterProvincia}`;
  };

  const handleChangeProvincia = (e) => {
    setFilterProvincia(e.target.value);
  };
//FTIIIIIIIIIIIIIIIIIIIIIIIIIILTROOOOOOOOOOOOOOOOO POR PROVINCIAAAAAAAAAAAAAAAAA
  const getDatosProvincias = () => {
    //console.log('hola q tal provincias')
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias?ended=false`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

const handleGetDatosProvincia = () => {
  getDatosProvincias()
    .then((response) => {
      
      setProvincias(response.items);
    })
    .catch(() => {
      props?.ErrorHandling();
    });
};

  return (
    <>
      <h2>Laicos</h2>
      <GenericExplorer url={`/usuarios${getQueryString()}`} ItemAddCard={LaicoAddTarjeta} ItemCard={LaicoTarjeta} userLevel={props.userLevel} provinciaLogueado={provinciaLogueado}>
        {//console.log(`/usuarios${getQueryString()}`)
        }
        <CustomNavBar expand="md">
          {/* Cuando se hace pequeña la pantalla */}
          <Navbar.Toggle aria-controls="Filtro Laicos" className="bg-light mb-3">
            <Image className="align-text-top" alt="" height="20" />
            <span className="align-text-bottom"> Filtros</span>
          </Navbar.Toggle>
          {/*          */}
          <Navbar.Collapse className="mb-3" id="basic-navbar-nav">
            <Form as="div" inline className="w-100">
            <FormControl type="text" onChange={handleChangeSearch} placeholder={"Búsqueda"} className="mr-1 w-25" />
              <TooltipIcon className={"mr-3"} content={"Búsqueda por nombre, apellidos o documento de identidad."} />  
              <InputGroup className="mr-3">
                <InputGroup.Prepend>
                  <InputGroup.Text>Provincias</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control as="select" onChange={handleChangeProvincia} custom value={filterProvincia}>
                  <option value="">Todas</option>
                  {provincias.length &&
                    provincias.map((provincia) => {
                      return (
                        <option key={provincia.id} value={provincia.id}>
                          {provincia.name}
                        </option>
                      );
                    })}
                </Form.Control>
              </InputGroup>
              <InputGroup className="mt-2">
                <Form.Group>
                  <Form.Check type="checkbox" label="Todos los laicos/as" defaultChecked={todosLaicos} value={todosLaicos} onClick={handleChangeTodasHermanas} />
                  <TooltipIcon className={"ml-1 pb-1"} content={"Al seleccionar esta opción se muestran todos los laicos y laicas que han cesado en la Congregación y aquellos que no tienen un destino asignado"} />
                </Form.Group>
              </InputGroup>
            </Form>
            
          </Navbar.Collapse>
          
        </CustomNavBar>
      </GenericExplorer>
    </>
  );
};

export default Laicos;
